/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './subscribeLabels.defs.js'
export * as $defs from './subscribeLabels.defs.js'
